import styled from '@emotion/styled';
import { Button, Dialog, DialogContent, Link, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { useDrawResultContext } from '../provider';

function SuccessDialog() {
  const { success, setSuccess } = useDrawResultContext();

  return (
    <BootstrapDialog
      open={success}
      onClose={() => setSuccess(false)}
    >
      <DialogContent sx={{ position: 'relative', px: 4, py: 4 }}>
        <ButtonClose onClick={() => setSuccess(false)}>
          <CloseIcon sx={{ fontSize: 20, color: '#7D7D7D' }} />
        </ButtonClose>

        <Stack alignItems="center" justifyContent="center" spacing={1.5}>
          <CheckCircleIcon sx={{ fontSize: 60, color: '#33BB48' }} />

          <Typography fontSize={26} fontWeight={700} color="#33BB48">
            Success
          </Typography>

          <Typography fontSize={14} color="#202224" textAlign="center">
            Banner and Description are now published on the Rewards website.
          </Typography>

          <ButtonOkay onClick={() => setSuccess(false)}>OKAY</ButtonOkay>

          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography fontSize={13} color="#202224">View:</Typography>
            <Link
              href="https://www.rewards.palmsplay.com/draw-result"
              target="_blank"
              rel="noopener noreferrer"
              fontSize={13}
              underline="always"
            >
              www.rewards.palmsplay.com/draw-result
            </Link>
          </Stack>
        </Stack>
      </DialogContent>
    </BootstrapDialog>
  );
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: 430,
    borderRadius: 20,
    margin: 0,
    padding: 0,
  },
}));

export const ButtonClose = styled(Button)(({ theme }) => ({
  minWidth: 0,
  width: 32,
  height: 32,
  color: '#7D7D7D',
  backgroundColor: 'white',
  position: 'absolute',
  top: 12,
  right: 12,
  padding: 0,
}));

export const ButtonOkay = styled(Button)(({ theme }) => ({
  width: '100%',
  height: 50,
  marginTop: 8,
  color: 'white',
  fontWeight: 700,
  fontSize: 14,
  borderRadius: 10,
  backgroundColor: '#6A00AC',
  '&:hover': { backgroundColor: '#520088' },
}));

export default SuccessDialog;
